// Personal information and contact details
export const personalInfo = {
  name: "Ariel Cohen",
  role: "Game Developer",
  bio: "Game programmer building clean systems and memorable interactive experiences.",
  avatar: "https://i.ibb.co/v67zkd7L/20190419-175428.jpg",
  skills: [
    'Game Dev',
    'Unreal Engine',
    'Unity Engine',
    'Maya',
    'C#',
    'Javascript'
  ],
  social: {
    github: {
      url: "https://github.com/MrARx2",
      label: "GitHub"
    },
    linkedin: {
      url: "https://www.linkedin.com/in/ariel-cohen-116804191/",
      label: "LinkedIn"
    },
    x: {
      url: "https://x.com/GamingMrar",
      label: "X (formerly Twitter)"
    }
  },
  resume: "/Resume/Ariel Cohen Resume.pdf"
};
